import { render, staticRenderFns } from "./list-1.vue?vue&type=template&id=65f11346&scoped=true"
import script from "./list-1.vue?vue&type=script&lang=js"
export * from "./list-1.vue?vue&type=script&lang=js"
import style0 from "./list-1.vue?vue&type=style&index=0&id=65f11346&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f11346",
  null
  
)

export default component.exports